import React from "react";
import FirstTask from "../FirstTask/FirstTask";
import OtherTask from "../OtherTask/OtherTask";

const HighPrio = () => {
  return (
    <div className="mb-6">
      {/* Top row: Priority tag (left) + Points tag (right) */}
      <div className="flex items-center justify-between">
        {/* Priority Tag */}
        <div className="w-20 h-5 bg-red-100 rounded-[10px] flex items-center justify-center text-xs font-medium text-gray-700">
          High Priority
        </div>

        {/* Points Tag */}
        <div className="w-10 h-3 bg-cyan-100 rounded-[10px] flex items-center justify-center">
          <span className="text-slate-400 text-[8px] font-medium font-['Inter']">
            90 pts
          </span>
        </div>
      </div>

      {/* First Task (aligned right) */}
      <div className="flex justify-end mt-2">
        <FirstTask label="Finish Dashboard Layout" />
      </div>

      {/* Other Tasks (stacked below first) */}
      <div className="flex flex-col items-end gap-1 mt-2">
        <OtherTask label="Polish UI Components" />
        <OtherTask label="Fix Navbar Spacing" />
        <OtherTask label="Refactor API Calls" />
      </div>

    </div>
  );
};

export default HighPrio;
